import React, { useContext } from 'react';
import { Context } from '../../../../../context/AppContext';
import './styles.css';

const Location = ({ distance, locations, servicing, regionCitySearch }) => {
  const {
    media: { tablet, desktop },
  } = useContext(Context);
  return (
    <div className="Listview__Card__location">
      {!regionCitySearch && !!distance && (
        <span className="Listview__Card__distance">{distance} km away</span>
      )}
      {servicing ||
        (locations && !!locations.length && locations[0].addressParts && (
          <address>
            {(tablet || desktop) && locations[0].addressParts.street && (
              <span>{locations[0].addressParts.street}</span>
            )}
            {locations[0].addressParts.suburb && (
              <span>{locations[0].addressParts.suburb} </span>
            )}
          </address>
        ))}
    </div>
  );
};

export default Location;
